/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ConfigurazioneFormTemplateDTO } from '../model/configurazione-form-template-dto';
// @ts-ignore
import { ConfigurazioneFormTranslateResponseDTO } from '../model/configurazione-form-translate-response-dto';
// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    TipoPraticaConfigurazioneFormEsercenteServiceInterface,
    PutTipoPraticaConfigurazioneFormEsercenteRequestParams,
    TranslateTipoPraticaConfigurazioneFormEsercenteRequestParams
} from './tipo-pratica-configurazione-form-esercente.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class TipoPraticaConfigurazioneFormEsercenteService extends BaseService implements TipoPraticaConfigurazioneFormEsercenteServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Salva il template di form esercente di un bando dopo validazione strutturale (sintassi $dynamic, profondita\&#39; max, params).
     * @endpoint put /api/v1/gestione/tipi-pratica/{id}/configurazione-form-esercente
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public putTipoPraticaConfigurazioneFormEsercente(requestParameters: PutTipoPraticaConfigurazioneFormEsercenteRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ConfigurazioneFormTemplateDTO>;
    public putTipoPraticaConfigurazioneFormEsercente(requestParameters: PutTipoPraticaConfigurazioneFormEsercenteRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ConfigurazioneFormTemplateDTO>>;
    public putTipoPraticaConfigurazioneFormEsercente(requestParameters: PutTipoPraticaConfigurazioneFormEsercenteRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ConfigurazioneFormTemplateDTO>>;
    public putTipoPraticaConfigurazioneFormEsercente(requestParameters: PutTipoPraticaConfigurazioneFormEsercenteRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling putTipoPraticaConfigurazioneFormEsercente.');
        }
        const configurazioneFormTemplateDTO = requestParameters?.configurazioneFormTemplateDTO;
        if (configurazioneFormTemplateDTO === null || configurazioneFormTemplateDTO === undefined) {
            throw new Error('Required parameter configurazioneFormTemplateDTO was null or undefined when calling putTipoPraticaConfigurazioneFormEsercente.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/configurazione-form-esercente`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ConfigurazioneFormTemplateDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: configurazioneFormTemplateDTO,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Dry-run del resolver sul template esercente: ritorna l\&#39;output atteso + warning per i $dynamic che producono 0 nodi.
     * @endpoint post /api/v1/gestione/tipi-pratica/{id}/configurazione-form-esercente/translate
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public translateTipoPraticaConfigurazioneFormEsercente(requestParameters: TranslateTipoPraticaConfigurazioneFormEsercenteRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ConfigurazioneFormTranslateResponseDTO>;
    public translateTipoPraticaConfigurazioneFormEsercente(requestParameters: TranslateTipoPraticaConfigurazioneFormEsercenteRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ConfigurazioneFormTranslateResponseDTO>>;
    public translateTipoPraticaConfigurazioneFormEsercente(requestParameters: TranslateTipoPraticaConfigurazioneFormEsercenteRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ConfigurazioneFormTranslateResponseDTO>>;
    public translateTipoPraticaConfigurazioneFormEsercente(requestParameters: TranslateTipoPraticaConfigurazioneFormEsercenteRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling translateTipoPraticaConfigurazioneFormEsercente.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/configurazione-form-esercente/translate`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ConfigurazioneFormTranslateResponseDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
